import { StrictMode, useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ConfigPage from './pages/ConfigPage';
import './styles.css';

function Root() {
  const [isConfig, setIsConfig] = useState(
    window.location.hash === '#config' || window.location.pathname === '/config',
  );

  useEffect(() => {
    const check = () =>
      setIsConfig(window.location.hash === '#config' || window.location.pathname === '/config');
    window.addEventListener('hashchange', check);
    window.addEventListener('popstate', check);
    return () => {
      window.removeEventListener('hashchange', check);
      window.removeEventListener('popstate', check);
    };
  }, []);

  return isConfig ? <ConfigPage /> : <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
